module.exports = __webpack_public_path__ + "img/bjtitle2.67698ad3.png";